export const DSN = "https://583eb3d4786b4b0791f6906ac68595cd@o60155.ingest.sentry.io/5790911";
